import { render } from "./DetalheComponent.vue?vue&type=template&id=0ab3ce5f&scoped=true"
import script from "./DetalheComponent.vue?vue&type=script&lang=js"
export * from "./DetalheComponent.vue?vue&type=script&lang=js"

import "./DetalheComponent.vue?vue&type=style&index=0&id=0ab3ce5f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab3ce5f"]])

export default __exports__